import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { HomesService } from './homes.service';
import { environment } from '../../../environments/environment.dev';
import { lastValueFrom, map, Observable, tap } from 'rxjs';

export interface YearDto {
  id: number;
  year: number;
  createdAt: Date;
  updatedAt: Date;
}

@Injectable({
  providedIn: 'root',
})
export class YearsService {
  private readonly http = inject(HttpClient);
  private readonly homesService = inject(HomesService);
  private endPoint: string = 'exercices';
  private baseUrl: string = environment.baseUrl;
  public readonly years = signal<YearDto[]>([]);
  public readonly currentYear = signal<number>(new Date().getFullYear());

  public async init(): Promise<number[]> {
    const promess = await lastValueFrom(this.fetchYears());

    return promess;
  }

  public insertNewYear(year: number): Observable<unknown> {
    return this.http.post(`${this.URL}`, { year });
  }

  public fetchYears(
    query: {
      page: number;
      limit: number;
    } = {
      page: 1,
      limit: 50,
    },
  ): Observable<number[]> {
    return this.http
      .get<{
        count: number;
        rows: YearDto[];
      }>(`${this.URL}`, { params: { ...query } })
      .pipe(
        map((res) => res.rows),
        tap((res) => {
          this.years.set([...res]);

          const defaultYearToSelect =
            res.find((y) => y.year === new Date().getFullYear())?.year ??
            res
              .filter((y) => y.year < new Date().getFullYear())
              .sort((a, b) => b.year - a.year)[0]?.year;

          this.currentYear.set(defaultYearToSelect);
        }),

        map((res) => res.map((el) => el.year)),
      );
  }

  get URL(): string {
    const homeName = this.homesService.currentVisitedHome$.value?.name;
    return `${this.baseUrl}/${homeName}/${this.endPoint}`;
  }
}
